export const actions = {
  BIBPREDSVG_LOAD_REQUESTED: 'BIBPREDSVG_LOAD_REQUESTED',
  BIBPREDSVG_LOAD_SUCCEEDED: 'BIBPREDSVG_LOAD_SUCCEEDED',
  BIBPREDSVG_LOAD_FAILED: 'BIBPREDSVG_LOAD_FAILED',

  DELETE_BIBPREDSVG_REQUESTED: 'DELETE_BIBPREDSVG_REQUESTED',
  DELETE_BIBPREDSVG_SUCCEEDED: 'DELETE_BIBPREDSVG_SUCCEEDED',
  DELETE_BIBPREDSVG_FAILED: 'DELETE_BIBPREDSVG_FAILED',

  BIBPREDSVG_BYID_LOAD_REQUESTED: 'BIBPREDSVG_BYID_LOAD_REQUESTED',
  BIBPREDSVG_BYID_LOAD_SUCCEEDED: 'BIBPREDSVG_BYID_LOAD_SUCCEEDED',
  BIBPREDSVG_BYID_LOAD_FILED: 'BIBPREDSVG_BYID_LOAD_FILED',

  BIBPREDSVG_BYID_LOAD_INSERT_REQUESTED: 'BIBPREDSVG_BYID_LOAD_INSERT_REQUESTED',
  BIBPREDSVG_BYID_LOAD_INSERT_SUCCEEDED: 'BIBPREDSVG_BYID_LOAD_INSERT_SUCCEEDED',
  BIBPREDSVG_BYID_LOAD_INSERT_FILED: 'BIBPREDSVG_BYID_LOAD_INSERT_FILED',

  BIBPREDSVG_BY_BIBPLANTILLA_ID_LOAD_REQUESTED: 'BIBPREDSVG_BY_BIBPLANTILLA_ID_LOAD_REQUESTED',
  BIBPREDSVG_BY_BIBPLANTILLA_ID_LOAD_SUCCEEDED: 'BIBPREDSVG_BY_BIBPLANTILLA_ID_LOAD_SUCCEEDED',
  BIBPREDSVG_BY_BIBPLANTILLA_ID_LOAD_FILED: 'BIBPREDSVG_BY_BIBPLANTILLA_ID_LOAD_FILED',

  BIBPREDSVG_BY_PRODUCTO_ID_LOAD_REQUESTED: 'BIBPREDSVG_BY_PRODUCTO_ID_LOAD_REQUESTED',
  BIBPREDSVG_BY_PRODUCTO_ID_LOAD_SUCCEEDED: 'BIBPREDSVG_BY_PRODUCTO_ID_LOAD_SUCCEEDED',
  BIBPREDSVG_BY_PRODUCTO_ID_LOAD_FILED: 'BIBPREDSVG_BY_PRODUCTO_ID_LOAD_FILED',

  BIBPREDSVG_INSERT_REQUESTED: 'BIBPREDSVG_INSERT_REQUESTED',
  BIBPREDSVG_INSERT_SUCCEEDED: 'BIBPREDSVG_INSERT_SUCCEEDED',
  BIBPREDSVG_INSERT_FAILED: 'BIBPREDSVG_INSERT_FAILED',

  BIBPREDSVG_UPDATE_REQUESTED: 'BIBPREDSVG_UPDATE_REQUESTED',
  BIBPREDSVG_UPDATE_SUCCEEDED: 'BIBPREDSVG_UPDATE_SUCCEEDED',
  BIBPREDSVG_UPDATE_FAILED: 'BIBPREDSVG_UPDATE_FAILED',

  BIBSPREDSVG_PRODUCTO_UPDATE_REQUESTED: 'BIBSPREDSVG_PRODUCTO_UPDATE_REQUESTED',
  BIBSPREDSVG_PRODUCTO_UPDATE_SUCCEEDED: 'BIBSPREDSVG_PRODUCTO_UPDATE_SUCCEEDED',
  BIBSPREDSVG_PRODUCTO_UPDATE_FAILED: 'BIBSPREDSVG_PRODUCTO_UPDATE_FAILED',

  BIBPREDSVG_FILTERED_LOAD_REQUESTED: 'BIBPREDSVG_FILTERED_LOAD_REQUESTED',
  BIBPREDSVG_FILTERED_LOAD_SUCCEEDED: 'BIBPREDSVG_FILTERED_LOAD_SUCCEEDED',
  BIBPREDSVG_FILTERED_LOAD_FAILED: 'BIBPREDSVG_FILTERED_LOAD_FAILED',

  ENUMS_LOAD_REQUESTED: 'ENUMS_LOAD_REQUESTED',
  ENUMS_LOAD_SUCCEEDED: 'ENUMS_LOAD_SUCCEEDED',
  ENUMS_LOAD_FAILED: 'ENUMS_LOAD_FAILED',

  UPDATE_BIBPREDSVG_OBJETOS: 'UPDATE_BIBPREDSVG_OBJETOS',
}

export const getBibPredSvgAction = dispatch => {
  dispatch({
    type: actions.BIBPREDSVG_LOAD_REQUESTED,
  })
}

export const deleteBibPredSvgAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_BIBPREDSVG_REQUESTED,
    payload: id,
  })
}

export const getBibPredSvgCreateEditByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.BIBPREDSVG_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.BIBPREDSVG_BYID_LOAD_INSERT_REQUESTED,
    })
  }
}

export const getBibPredSvgByBibPlantillaIdAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBPREDSVG_BY_BIBPLANTILLA_ID_LOAD_REQUESTED,
    payload: id,
  })
}

export const getBibPredSvgByProductoIdAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBPREDSVG_BY_PRODUCTO_ID_LOAD_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertBibPredSvgFormAction = (dispatch, formBibPredSvg) => {
  dispatch({
    type: actions.BIBPREDSVG_INSERT_REQUESTED,
    payload: formBibPredSvg,
  })
}

export const onSubmitUpdateBibPredSvgFormAction = (dispatch, formBibPredSvg) => {
  dispatch({
    type: actions.BIBPREDSVG_UPDATE_REQUESTED,
    payload: formBibPredSvg,
  })
}

export const updateBibsPredSvgProductoAction = (dispatch, payload) => {
  dispatch({
    type: actions.BIBSPREDSVG_PRODUCTO_UPDATE_REQUESTED,
    payload,
  })
}

export const getBibPredSvgFilteredAction = (dispatch, filter) => {
  dispatch({
    type: actions.BIBPREDSVG_FILTERED_LOAD_REQUESTED,
    payload: filter,
  })
}
export const getEnumsAction = dispatch => {
  dispatch({
    type: actions.ENUMS_LOAD_REQUESTED,
  })
}

export const updateBibPredSvgObjetosAction = (dispatch, objetosSvg) => {
  dispatch({
    type: actions.UPDATE_BIBPREDSVG_OBJETOS,
    payload: objetosSvg,
  })
}
